import React from 'react';
import { graphql } from 'gatsby';
import HtmlContent from '../../Html';
import { Section } from '../../Section';

export const Html = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow' || data.narrow} {...rest}>
    <HtmlContent>{data.text}</HtmlContent>
  </Section>
);

export const HtmlQuery = graphql`
  fragment Html on KFH_UmbracoRichTextComponentType {
    text
    narrow
  }
`;
